var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashbord(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.9 1.8V6.3C9.9 7.29411 10.7059 8.1 11.7 8.1H16.2C17.1941 8.1 18 7.29411 18 6.3L18 1.8C18 0.805887 17.1941 0 16.2 0L11.7 0C10.7059 0 9.9 0.805887 9.9 1.8ZM16.2 6.3H11.7V1.8L16.2 1.8L16.2 6.3ZM1.8 9.9L16.2 9.9C17.1941 9.9 18 10.7059 18 11.7V16.2C18 17.1941 17.1941 18 16.2 18L1.8 18C0.805887 18 0 17.1941 0 16.2L0 11.7C0 10.7059 0.805887 9.9 1.8 9.9ZM1.8 11.7L1.8 16.2L16.2 16.2V11.7L1.8 11.7ZM0 1.8L0 6.3C0 7.29411 0.805887 8.1 1.8 8.1H6.3C7.29411 8.1 8.1 7.29411 8.1 6.3V1.8C8.1 0.805887 7.29411 0 6.3 0H1.8C0.805887 0 0 0.805887 0 1.8ZM6.3 6.3H1.8L1.8 1.8H6.3V6.3Z",
    fill: "#607783"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashbord);
export default __webpack_public_path__ + "static/media/dashbord.e2bb14868136a4f30b179bb8dd433322.svg";
export { ForwardRef as ReactComponent };